import { FC } from 'react'
import {
  LatestContractDtoFragment,
  CareerPathEvaluation,
  FullMeetingFragment,
  GovernmentJobTitle,
  CountrySettingsFragment,
} from '../../../types'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { ContractChangeWithObjectPayload } from './types'
import { ContractChangeModal } from './ContractChangeModal'
import useContractChangeValidationList from '../../../graphql/contract/hooks/useContractChangeValidationList'

type Props = {
  meeting: FullMeetingFragment
  currentContract: LatestContractDtoFragment
  change: ContractChangeWithObjectPayload
  visible: boolean
  closeModal: () => void
  datesOfCurrentChanges: Date[]
  careerPathEvaluation?: CareerPathEvaluation | null
  scheduledChanges: string
  isEdit: boolean
  isDeleting: boolean
  isPreparation?: boolean
  editedDate?: string
  hasNationalContractReference: boolean
  governmentJobTitlesByHiringOffice?: GovernmentJobTitle[]
  countrySettings: CountrySettingsFragment
}

export const ContractChangeModalWithValidationList: FC<Props> = ({
  meeting,
  currentContract,
  change,
  visible,
  closeModal,
  datesOfCurrentChanges,
  careerPathEvaluation,
  scheduledChanges,
  isEdit,
  isDeleting,
  isPreparation = false,
  editedDate,
  hasNationalContractReference,
  governmentJobTitlesByHiringOffice,
  countrySettings,
}) => {
  const employeeId: number = meeting.employee.id

  const { loading, error, data } = useContractChangeValidationList(employeeId, currentContract.legalEntity.country)

  if (loading || error || !data || !data.contractChangeValidationList || !data.employeeLevels) {
    return (
      <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.contractChangeValidationList || !data.employeeLevels} error={error} />
    )
  }

  return (
    <ContractChangeModal
      meeting={meeting}
      currentContract={currentContract}
      change={change}
      visible={visible}
      closeModal={closeModal}
      datesOfCurrentChanges={datesOfCurrentChanges}
      careerPathEvaluation={careerPathEvaluation}
      scheduledChanges={scheduledChanges}
      isEdit={isEdit}
      isDeleting={isDeleting}
      isPreparation={isPreparation}
      editedDate={editedDate}
      contractChangeValidationList={data.contractChangeValidationList}
      hasNationalContractReference={hasNationalContractReference}
      isEmployeeLevelValidationEnabled={data.isEmployeeLevelValidationEnabled}
      governmentJobTitlesByHiringOffice={governmentJobTitlesByHiringOffice}
      countrySettings={countrySettings}
      employeeLevels={data.employeeLevels}
    />
  )
}
